import { NotificationPayloadT } from 'lib-shared-legacy-types';
import { useCallback } from 'react';

import { notificationActions } from 'components/notifications/actions/notification';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export enum NotificationType {
  Error,
  Success,
}

export type NotificationCallback = (
  notification: NotificationPayloadT,
  type?: NotificationType,
) => void;

const NOTIFICATION_MAP: Record<
  NotificationType,
  Partial<NotificationPayloadT>
> = {
  [NotificationType.Error]: {
    title: 'An error occurred',
    className: 'danger',
    icon: 'exclamation',
  },
  [NotificationType.Success]: {
    title: 'Success',
    className: 'success',
    icon: 'done',
  },
};
const { notificationAdd } = notificationActions;

export const useNotifications = (): NotificationCallback => {
  const dispatch = useAppDispatch();
  const addNotification = useCallback<NotificationCallback>(
    (payload, type) => {
      const notificationTypeDefaultValues = NOTIFICATION_MAP[type ?? ''] || {};
      const notification: NotificationPayloadT = {
        ...notificationTypeDefaultValues,
        ...payload,
      };

      dispatch(notificationAdd(notification));
    },
    [dispatch],
  );

  return addNotification;
};
